// MESSAGES
import AdminFormattedMessages from '../messages/admin/AdminFormattedMessages';

export const AdminRoutes = [
  {
    path: '/admin/provider',
    label: AdminFormattedMessages.provider,
    accessLevel: '3',
    accessType: '3',
  },
  {
    path: '/admin/customers',
    label: AdminFormattedMessages.customers,
    accessLevel: '3',
    accessType: '3',
  },
  {
    path: '/admin/errorlog',
    label: AdminFormattedMessages.errorLog,
    accessLevel: '3',
    accessType: '3',
  },
  {
    path: '/admin/tracelog',
    label: AdminFormattedMessages.traceLog,
    accessLevel: '3',
    accessType: '3',
  },
  {
    path: '/admin/service-config',
    label: AdminFormattedMessages.serviceConfig,
    accessLevel: '3',
    accessType: '3',
  },
  {
    path: '/admin/tariffs',
    label: AdminFormattedMessages.tariffing,
    accessLevel: '3',
    accessType: '3',
  },
  {
    path: '/admin/find-customer',
    label: AdminFormattedMessages.findCustomer,
    accessLevel: '3',
    accessType: '3',
  },
  {
    path: '/admin/system-monitor',
    label: AdminFormattedMessages.systemMonitor,
    accessLevel: '3',
    accessType: '3',
  },
  {
    path: '/admin/debug',
    label: AdminFormattedMessages.debug,
    accessLevel: '3',
    accessType: '3',
  },
  {
    path: '/admin/compliance',
    label: AdminFormattedMessages.compliance,
    accessLevel: '3',
    accessType: '3',
  },
];
